const Types = {
    USER_ACTIVATION_CHECK: "USER_ACTIVATION_CHECK",
    USER_ACTIVATION_ERROR: "USER_ACTIVATION_ERROR",
    USER_ACTIVATION_REQUEST: "USER_ACTIVATION_REQUEST",
};

export default Types;
